// Écrans de création d'un module (H9-01, D-036) : quand le module est désactivé dans la collectivité,
// l'écran dit « Module non activé » au lieu du formulaire ; les listes et les fiches, elles, restent
// accessibles. L'état des modules vient de GET /contexte (modules_actifs), connu de tout agent.
import { MODULES, type CodeModule } from '@cc/contrats';
import { EtatVide, LienBouton } from '@cc/ui';
import { LayoutGrid } from 'lucide-react';
import { useSession } from '../session/FournisseurSession';
import { moduleActif } from '../session/permissions';

/** true ou false selon le contexte ; null tant que le serveur n'annonce pas ses modules (ancienne API). */
export function useModuleActif(module: CodeModule): boolean | null {
  const { contexte } = useSession();
  return moduleActif(contexte, module);
}

export function ModuleNonActive({ module, retour }: { module: CodeModule; retour: { href: string; libelle: string } }) {
  return (
    <EtatVide titre="Module non activé" niveau={2} icone={LayoutGrid} action={<LienBouton href={retour.href}>{retour.libelle}</LienBouton>}>
      <p>
        Le module {module} ({MODULES[module]}) est désactivé dans cette collectivité : aucune nouvelle création n&apos;est possible. L&apos;existant reste
        consultable.
      </p>
    </EtatVide>
  );
}
